import { useCallback, useEffect, useMemo } from "react";

import { useEditor } from "@craftjs/core";
import { set } from "lodash";

import { useCraftOptions } from "./useCraftOptions";

export function useOptions({ value: show }) {
  const { actions: { setHidden } } = useEditor()

  const { setValue: setCustom, options } = useCraftOptions()

  useEffect(() => {
    for (const { id, value } of options) {
      id && setHidden(id, value !== show)
    }
    return () => {
      for (const { id } of options) {
        try {
          id && setHidden(id, false)
        } catch (error) {
          // ignore error
        }
      }
    }
  }, [options, setHidden, show])

  const register = useCallback((name, value) => setCustom(custom => set(custom, `options.${name}`, value)), [setCustom])
  const reset = useCallback(() => setCustom(custom => set(custom, 'options', [])), [setCustom])

  return useMemo(() => ({
    register,
    reset,
    value: options,
  }), [register, reset, options])
}
